import { axios, baseURL } from '@/plugins/axios.js'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchProducts(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/products', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createProduct(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/products', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateProduct(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/products/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchProducts(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/products/active', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProductGroups(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/product_groups')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCategories(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/categories', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSubcategories(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/subcategories')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProductBrands(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/product_brands')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProductUnits(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/units')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createProductGroup(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/product_groups', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createCategory(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/categories', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createSubcategory(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/subcategories', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createProductBrand(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/product_brands', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createProductUnit(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/units', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProductSummary(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`api/v1/products/${params.id}/summary`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    lockedProduct(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/products/${params.id}/locked`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    advancedSearchProducts(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/products/advanced', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    editEventLogs(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/edit_events', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    exportStockList(ctx, params) {
      return new Promise((resolve, reject) => {
        const urlParams = new URLSearchParams();
        urlParams.append("product_brand_id", params.export_stock.product_brand_id || "");
        urlParams.append("main_group", params.export_stock.main_group || "")
        urlParams.append("product_group_id", params.export_stock.product_group_id || "")
        urlParams.append("product_group", params.export_stock.product_group || "")
        urlParams.append("category", params.export_stock.category || "")
        urlParams.append("location", params.export_stock.location || "")
        urlParams.append("status", params.export_stock.status || "")
        fetch(`${baseURL}/api/v1/products/stock_list?${urlParams}`, {
          method: "GET",
          headers: Object.assign($cookies.get("userAuth"), { "Access-Control-Allow-Origin": "*" })
        })
          .then((response) => {
            resolve(response.blob());
          })
          .catch((error) => reject(error));
      });
    },
    exportStockInAndOut(ctx, params) {
      return new Promise((resolve, reject) => {
        const urlParams = new URLSearchParams();
        urlParams.append("product_id", params.product_id || "")
        urlParams.append("start_date", params.start_date || "")
        urlParams.append("end_date", params.end_date || "")
        fetch(`${baseURL}/api/v1/products/export?${urlParams}`, {
          method: "GET",
          headers: Object.assign($cookies.get("userAuth"), { "Access-Control-Allow-Origin": "*" })
        })
          .then((response) => {
            resolve(response.blob());
          })
          .catch((error) => reject(error));
      });
    },
    fetchFavouriteProducts(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/favourite_products', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createFavouriteProduct(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/favourite_products', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateFavouriteProduct(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/favourite_products/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteFavouriteProduct(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/favourite_products/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    sortFavouriteProduct(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/favourite_products/${params.id}/sort`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    setFavouriteProduct(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/favourite_products/${params.id}/favourite`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeFavouriteProduct(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/favourite_products/${params.id}/remove`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    currentFavouriteProduct(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/favourite_products/${params.id}/current`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}